import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.25 10.18V7A3.75 3.75 0 0 1 7 3.25h10A3.75 3.75 0 0 1 20.75 7v3.18c.25.438.41.923.472 1.426a2.75 2.75 0 0 1 1.528 2.464V17a1.76 1.76 0 0 1-1 1.578V20a.76.76 0 0 1-.75.75.76.76 0 0 1-.75-.75v-1.25H3.75V20a.76.76 0 0 1-.75.75.76.76 0 0 1-.75-.75v-1.419a1.75 1.75 0 0 1-1-1.581v-2.93a2.75 2.75 0 0 1 1.528-2.464 3.8 3.8 0 0 1 .472-1.425m16-1.469V7A2.25 2.25 0 0 0 17 4.75H7A2.25 2.25 0 0 0 4.75 7v1.711a3.8 3.8 0 0 1 1.82-.461H8.9a3.35 3.35 0 0 1 2.72 1.394q.116-.143.249-.275A3.82 3.82 0 0 1 14.57 8.25h2.86a3.8 3.8 0 0 1 1.82.461M21 17.25a.25.25 0 0 0 .25-.25v-2.93A1.25 1.25 0 0 0 20 12.82H4a1.25 1.25 0 0 0-1.25 1.25V17a.25.25 0 0 0 .25.25m16.62-5.93h-7.245q.023-.069.052-.138A2.32 2.32 0 0 1 14.57 9.75h2.86a2.34 2.34 0 0 1 2.19 1.57m-8.891 0A1.85 1.85 0 0 0 8.9 9.75H6.57a2.32 2.32 0 0 0-2.195 1.57z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }